// extracted by mini-css-extract-plugin
export default {"header":"FormHeader_header__ISbjY"};